/**
 * Arma los filtros del tablero de PowerBI embebido a partir de la respuesta de
 * /power-bi/embed-data/*. Cada campo llega como lista de ids; si el campo no
 * viene, el usuario no se filtra por esa dimensión. Lista vacía = usuario
 * restringido sin asignaciones: se manda [-1] para que el tablero no muestre nada.
 *
 * `bases`, `regiones` y `subregiones` (VEC-2449) filtran sobre las tablas propias
 * del modelo de PowerBI (pendiente de confirmación de BI, pregunta 1 de la card).
 */
const filtroPorIds = (table, column, ids) => ({
	$schema: "http://powerbi.com/product/schema#basic",
	target: { table, column },
	operator: "In",
	values: ids.length === 0 ? [-1] : ids
});

export function armarFiltrosPowerBI(data) {
	const filtros = [];
	if (Array.isArray(data.transportadoras)) {
		filtros.push(filtroPorIds("movil_transportadora", "transportadora_id", data.transportadoras));
	}
	if (Array.isArray(data.bases)) {
		filtros.push(filtroPorIds("bases", "id", data.bases));
	}
	if (Array.isArray(data.regiones)) {
		filtros.push(filtroPorIds("regiones", "id", data.regiones));
	}
	if (Array.isArray(data.subregiones)) {
		filtros.push(filtroPorIds("subregiones", "id", data.subregiones));
	}
	return filtros;
}
